export default __webpack_public_path__ + "static/media/socialimpact7.35e6fb2a.jpeg";